var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPinGrey = function SvgPinGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 63,
    viewBox: "0 0 42 63"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 21a10.5 10.5 0 10-3.076 7.424A10.116 10.116 0 0031.5 21zM42 21a17.261 17.261 0 01-1.354 7.342l-14.93 31.746a4.977 4.977 0 01-1.948 2.133 5.307 5.307 0 01-5.537 0 4.724 4.724 0 01-1.907-2.133L1.353 28.342A17.26 17.26 0 010 21a21 21 0 0142 0z",
    fill: "#696b6c"
  })));
};
export default SvgPinGrey;